import { DocsPage } from "../../../views/pages/docs/DocsPage"
import { DomainForm } from "../../../views/pages/domains/DomainForm"
import { DomainScreen } from "../../../views/pages/domains/DomainScreen"

const DomainRoutes = [
    {
        path: '/domains',
        exact: true,
        layout: 'HorizontalLayout',
        component: () => <DomainScreen />,
        meta: {
            action: 'read',
            resource: 'domains'
        }
    },
    {
        path: '/domains/:id',
        exact: true,
        layout: 'HorizontalLayout',
        component: () => <DomainForm />,
        meta: {
            action: 'insert',
            resource: 'domains'
        }
    },
    {
        path: '/documentation',
        exact: true,
        layout: 'BlankLayout',
        component: () => <DocsPage />,
        meta: {
            publicRoute: true
        }
    }
]

export default DomainRoutes
